import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProofStats() {
  const stats = [{
    value: '+800',
    label: 'Profesionales confían en el sistema'
  }, {
    value: '4.9/5',
    label: 'Valoración promedio'
  }, {
    value: '+180',
    label: 'Recursos clínicos y protocolos'
  }, {
    value: '#1',
    label: 'Sistema elegido en Argentina'
  }];
  return <section className="py-10 px-4 bg-slate-950" data-id="element-117">
      <div className="max-w-md mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-119">
          <div className="flex items-center justify-center gap-1 mb-2" data-id="element-120">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-121" />)}
            <span className="text-white font-bold ml-2 text-sm" data-id="element-122">4.9/5</span>
          </div>
          <p className="text-white font-bold text-base" data-id="element-123">
            Elegido por ortopedistas en toda Argentina
          </p>
          <p className="text-slate-400 text-xs mt-1" data-id="element-124">
            El sistema de evaluación y seguimiento ortopédico más completo y
            profesional del mercado
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-2 gap-3" data-id="element-125">
          {stats.map((stat, i) => <div key={i} className="bg-slate-900 border border-slate-800 rounded-xl p-4 text-center" data-id="element-126">
              <p className="text-2xl md:text-3xl font-black text-teal-400" data-id="element-127">
                {stat.value}
              </p>
              <p className="text-slate-400 text-xs mt-1" data-id="element-128">{stat.label}</p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}